import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const getMetricCardsWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${length}, 1fr)`,
  },
});

export const metricCardStyles = {
  padding: '4px 8px',
};

export const pitiTooltipStyles = {
  padding: '24px',
  maxWidth: 'none',
  color: ({ palette }) => palette.text.primary,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.s,
};
